const scrollToRefElement = (ref) => ref?.current?.scrollIntoView();

export default scrollToRefElement;
